export default __webpack_public_path__ + "static/avatar-tag-2-do-light-65b6b427dd8739d17c6a674b737abbac.png";